import { ClerkProvider } from '@clerk/react'
import { domAnimation, LazyMotion, MotionConfig } from 'motion/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { AuthSync } from './components/auth-sync.tsx'
import { DevConfigWarning } from './components/dev-config-warning.tsx'
import { AppBoot } from './components/loading/app-boot-screen.tsx'
import './globals.css'
import { CLERK_APPEARANCE } from './lib/clerk-appearance.ts'
import { router } from './router.tsx'

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

// PostHog validation/init now lives in ./lib/posthog.ts and is deferred until after first
// paint (RAL-142) — see that file for why. AuthSync kicks off the deferred load.

// appearance at the provider themes every Clerk surface (SignIn, UserButton,
// and the full-screen UserProfile alike) with the command-center palette.
// biome-ignore lint/style/noNonNullAssertion: root element always exists
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* LazyMotion + the "m" component (not "motion") keeps the ~30kb animation feature
        bundle out of the main chunk; "strict" throws if a component ever reaches for
        "motion.*" instead. reducedMotion="user" is motion/react's built-in
        prefers-reduced-motion handling: it disables transform-driven animation
        (movement, scale) while leaving simple opacity fades in place, so this is the
        one place the guard needs to live. */}
    <LazyMotion features={domAnimation} strict>
      <MotionConfig reducedMotion="user">
        <ClerkProvider
          publishableKey={CLERK_PUBLISHABLE_KEY}
          appearance={CLERK_APPEARANCE}
          signInFallbackRedirectUrl="/"
          signUpFallbackRedirectUrl="/"
        >
          <AuthSync />
          {/* Renders only when a dev param is missing; null in production and under test. */}
          <DevConfigWarning />
          {/* Above the router on purpose: RouterProvider renders nothing until its initial
              loaders resolve, so without this a cold boot is a bare void page (RAL-183). */}
          <AppBoot />
          <RouterProvider router={router} />
        </ClerkProvider>
      </MotionConfig>
    </LazyMotion>
  </StrictMode>
)
